import React, { FC } from 'react'

import { HowToSellContainer } from './HowToSellContainer'
import * as Styled from './styled'

export const NoSalesContainer: FC = () => {
  return (
    <>
      <Styled.Container>
        <Styled.Header>
          <Styled.Icon />
          <div>
            <Styled.Title>No sales yet!</Styled.Title>
            <Styled.Description>Start selling products and accumulate rewards.</Styled.Description>
          </div>
        </Styled.Header>
        <Styled.Actions>
          <Styled.LinkPrimaryButton to="/account/dispensary/customize/homepage">
            <Styled.CustomizeIcon />
            Customize your Virtual Dispensary
          </Styled.LinkPrimaryButton>
          <Styled.LinkSecondaryButton to="/escript/protocols">
            <Styled.StartEscriptIcon />
            Start an eScript from a protocol
          </Styled.LinkSecondaryButton>
        </Styled.Actions>
      </Styled.Container>
      <HowToSellContainer />
    </>
  )
}

export default NoSalesContainer
